import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { purgeStoredState } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import Error from '../components/Error';
import { ERROR_MESSAGE } from '../constants/PropTypesShapes';
import l10n from '../../lib/reactPPl10nHelper';
import { trackPage } from '../../lib/analytics-helper';

const errorMessage = {
  message: l10n.getContent('smarthelp/Error.error.message'),
  tryAgain: l10n.getContent('smarthelp/Error.error.tryAgain'),
};

class ErrorHandler extends Component {
  render() {
    if (this.props.isError) {
      purgeStoredState({ storage: asyncSessionStorage }).then(() => {
        // purge completed
        // Send impression FPTI for loaded Error page
        trackPage({ id: 'ErrorPage', link: 'smarthelp-error-handler' });
      });
      return <Error message={this.props.contactError.message} tryAgain={this.props.contactError.tryAgain} />;
    }
    return this.props.children;
  }
}
function mapStateToProps(state) {
  return {
    isError: state.errors.isError,
  };
}

ErrorHandler.propTypes = {
  children: PropTypes.element,
  isError: PropTypes.bool.isRequired,
  contactError: PropTypes.shape(ERROR_MESSAGE),
};

ErrorHandler.defaultProps = {
  children: undefined,
  contactError: {
    message: errorMessage.message,
    tryAgain: errorMessage.tryAgain,
  },
};

export default connect(mapStateToProps)(ErrorHandler);
